import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IEcranDetailsResourcesEntite} from '../../../../../core/resources/ecran-details.resource';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IParametresRechercheService} from '../../../../../core/services/parametres-recherche.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';

interface IPageSo0016 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function So0016Controller(Menu: IMenuClass,
                                         parametresRecherche: IParametresRechercheService,
                                         Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         ecranDetails: IEcranDetailsResourcesEntite) {
    const vm: IPageSo0016 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesFixesGauche: [
            {nom: 'unocodrh', largeur: 130}
        ],
        colonnesVisibles: [
            {nom: 'unodscabrrh', largeur: 233},
            {nom: 'urgcod', largeur: 180},
            {nom: 'urgdscabr', largeur: 253},
            {nom: 'temcod', largeur: 120},
            {nom: 'temdscabr', largeur: 233},
            {nom: 'unocodvac', largeur: 130},
            {nom: 'unodscabrvac', largeur: 233}
        ],
        formulaire: new Formulaire([
                new FormulaireItem('unocleintrh', {required: true, largeur: 50}),
                new FormulaireItem('urgcleint', {largeur: 50}),
                new FormulaireItem('temcleint', {largeur: 50}),
                new FormulaireItem('unocleintvac', {largeur: 50})
            ]
        )
    };
}
